import React from 'react';
import PropTypes from 'prop-types';
import { withLocalize } from 'react-localize-redux';
import classNames from 'classnames';
import css from './Tag.css';
import OverflowingText from '../foundations/OverflowingText';

const Tag = ({
    value,
    shouldTranslate,
    color = null,
    className,
    leftIcon,
    rightIcon,
    isFadingBackground = true,
    onClick,
    translate,
    translationData,
    hidePreview = false,
}) => {
    return (
        <div
            className={classNames(css.tag, className, {
                [css.fadingBackground]: isFadingBackground,
                [css.clickable]: !!onClick,
            })}
            style={{ '--dynamicColor': color }}
            onClick={onClick}
        >
            {leftIcon}
            <OverflowingText className={css.text} hidePreview={hidePreview}>
                {shouldTranslate ? translate(value, translationData) : value}
            </OverflowingText>
            {rightIcon}
        </div>
    );
};

Tag.propTypes = {
    value: PropTypes.string.isRequired,
    shouldTranslate: PropTypes.bool,
    color: PropTypes.string,
    className: PropTypes.string,
    leftIcon: PropTypes.element,
    rightIcon: PropTypes.element,
    isFadingBackground: PropTypes.bool,
    onClick: PropTypes.func,
    translate: PropTypes.func,
    translationData: PropTypes.shape({}),
    hidePreview: PropTypes.bool,
};

export default withLocalize(Tag);
